import { Button, DialogActions, DialogContent, DialogContentText, TextField } from '@mui/material'
import apiManagerRoom from 'api/manager-meeting'
import { ReactComponent as IconLogoSecond } from 'assets/icons/IconLogoSecond.svg'
import { DOMAIN_MEETING } from 'constants/api'
import { NS_TRANS } from 'constants/common'
import { useMenuCC, useTheme } from 'hooks'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import theme from 'theme'
import { handleEnterKeyFunc } from 'utils/functions/common'
import PopoverCC from './PopoverCC'
import './Popover.css'

const PopoverJoinNowCC = ({alawaysShow = false}) => {
    const {t} = useTranslation([NS_TRANS.MANAGE_MEETING])
    const { open, anchorEl, setAnchorEl } = useMenuCC()
    const [ roomName, setRoomName] = useState(t('pgMeeting:immediatelyRoom'))
    const { secondaryInitalColor } = useTheme()

    const handleOpenPopover = (e) => {
        setAnchorEl(e.currentTarget)
        setRoomName(t('pgMeeting:immediatelyRoom'))
    }

    const handleChangeRoomName = (e) => {
        setRoomName(e.target.value)
    }

    const handleJoinNow = async _ => {
        try {
            const res = await apiManagerRoom.joinNow(roomName || t('pgMeeting:immediatelyRoom'))

            if(res.status === 200) {
                window.open(`${DOMAIN_MEETING}/${res.data.roomId}`, "_self")
                setAnchorEl(undefined)
            } else {
                console.log("res.", res)    
            }
        } catch (err) {
            console.log("err.", err)
        }
    }

    return (
        <React.Fragment>
            <Button id='btn-join-now' className={anchorEl ? 'show-arrow' : ''} onClick={handleOpenPopover} variant='outlined' sx={{ display: { xs: alawaysShow ? 'flex' : 'none', sm: 'flex' }, 'svg path:nth-child(-n+2)': { fill: `${secondaryInitalColor} !important`} }} startIcon={<IconLogoSecond />}>{t('mnMeeting.joinNow', {ns: NS_TRANS.BTN})}</Button>
            <PopoverCC title={t('popover.titleJoinNow')} open={open} setAnchorEl={setAnchorEl} anchorEl={anchorEl} >
                <DialogContent>
                    <DialogContentText>
                        {t('popover.roomName')}    
                    </DialogContentText>
                    <TextField 
                        autoFocus 
                        fullWidth 
                        placeholder={t('popover.placeholderJoinNow')} 
                        value={roomName} 
                        onChange={handleChangeRoomName} 
                        onKeyPress={(e) => handleEnterKeyFunc(e, handleJoinNow)} 
                        sx={{ marginTop: theme.spacing(0.5) }} 
                        error={roomName.length > 100 || roomName.length === 0}
                        helperText={(roomName.length > 100 && t('validate.max-length')) || (roomName.length === 0 && t('validate.min-length'))}
                    />
                </DialogContent>
                <DialogActions sx={{ display: 'flex', flexDirection: 'column', rowGap: '1rem', marginTop: '0.5rem' }}>
                    <Button 
                        onClick={handleJoinNow} 
                        sx={{ width: 1, margin: '0 !important' }}
                        disabled={roomName.length > 100 || roomName.length === 0}
                    >{t('popover.start')}</Button>
                </DialogActions>
            </PopoverCC>
        </React.Fragment>
    )
}

export default PopoverJoinNowCC